// Calculo da ficha de pizza no front — espelho de api/v1/pizza/fichas.py.
// Se mudar a regra, mude nos dois.
//
// Meio a meio: cada sabor entra com 1/N de TUDO (massa inclusive) — 0,5 massa + 0,5 massa = 1.
// Forma dos dados: "porTamanho" = { [size_id]: [ {ingredient_id, quantity, item_type} ] }.
// E' assim que `products.pizza_recipes` (sabor) e `pizza_fichas.sizes` (base) sao
// gravados. A tela mostra a ficha padrao do sistema com um campo de quantidade
// por tamanho em cada linha.

/** Custo de `q` de um ingrediente (kg+uw: un; un+uw: kg; senao unidade base; + perda). */
export function custoLinha(ing, q) {
  if (!ing) return 0;
  const avg = Number(ing.average_price) || 0;
  const uw = Number(ing.unit_weight) || 0;
  const unit = ing.unit || "";
  const loss = Number(ing.loss_percent) || 0;
  const lf = loss > 0 && loss < 100 ? 1 / (1 - loss / 100) : 1;
  const base = unit === "kg" && uw > 0 ? avg * uw * q : unit === "un" && uw > 0 ? (avg / uw) * q : avg * q;
  return base * lf;
}

const linhasValidas = (rows) => (rows || []).filter((r) => r && r.ingredient_id && Number(r.quantity) > 0);
const tipoDe = (r) => (r?.item_type === "packaging" ? "packaging" : "ingredient");

/** Custo total de uma lista de linhas (opcionalmente so de um tipo). */
export function custoFicha(rows, porId, tipo) {
  return linhasValidas(rows).filter((r) => !tipo || tipoDe(r) === tipo)
    .reduce((s, r) => s + custoLinha(porId[r.ingredient_id], Number(r.quantity)), 0);
}

/** q/n arredondado PRA CIMA na 3a casa (1/3 -> 0,334; 0,5 fica 0,5). Espelho do backend. */
export function fracao(q, n) {
  return Math.ceil((Number(q) / Math.max(1, n)) * 1000 - 1e-9) / 1000;
}

/** Quanto deste sabor entra numa pizza de `n` sabores (1/N de tudo, sem arredondar pra peca). */
export function consumoSabor(rows, n) {
  return linhasValidas(rows).map((r) => ({ ...r, quantity: n > 1 ? fracao(r.quantity, n) : Number(r.quantity) }));
}

/** Ids de ingrediente presentes em qualquer tamanho (de um tipo), na ordem em que aparecem. */
export function ingredientesDaFicha(porTamanho, tipo) {
  const vistos = [];
  for (const rows of Object.values(porTamanho || {})) {
    for (const r of rows || []) {
      if (r?.ingredient_id && (!tipo || tipoDe(r) === tipo) && !vistos.includes(r.ingredient_id)) vistos.push(r.ingredient_id);
    }
  }
  return vistos;
}

export function qtdDe(porTamanho, sid, iid) {
  const r = ((porTamanho || {})[sid] || []).find((x) => x.ingredient_id === iid);
  return r == null ? "" : r.quantity;
}

/** Define a quantidade de UM ingrediente em UM tamanho (linha criada se nao existir). */
export function definirQtd(porTamanho, sid, iid, q, tipo) {
  const atuais = (porTamanho || {})[sid] || [];
  const existente = atuais.find((x) => x.ingredient_id === iid);
  const rows = atuais.filter((x) => x.ingredient_id !== iid);
  rows.push({ ingredient_id: iid, quantity: q, item_type: tipo || existente?.item_type || "ingredient" });
  return { ...(porTamanho || {}), [sid]: rows };
}

/** Ingrediente novo entra com quantidade 1 em todos os tamanhos (como a ficha
 *  padrao, que adiciona com qtd 1) — o lojista ajusta cada coluna. */
export function adicionarIngrediente(porTamanho, sizes, iid, tipo = "ingredient") {
  let next = { ...(porTamanho || {}) };
  for (const sz of sizes || []) {
    if (!((next[sz.id] || []).some((x) => x.ingredient_id === iid))) next = definirQtd(next, sz.id, iid, "1", tipo);
  }
  return next;
}

export function removerIngrediente(porTamanho, iid) {
  const next = {};
  for (const [sid, rows] of Object.entries(porTamanho || {})) next[sid] = (rows || []).filter((x) => x.ingredient_id !== iid);
  return next;
}

/** {size_id: custo} de uma estrutura porTamanho (opcionalmente so de um tipo). */
export function custoPorTamanho(porTamanho, sizes, porId, tipo) {
  const out = {};
  for (const sz of sizes || []) out[sz.id] = custoFicha((porTamanho || {})[sz.id], porId, tipo);
  return out;
}
